import React from 'react'
import Body1 from "../Template/Body/Body";


function Template1() {
  return (
    <div>
      
      <Body1/>
      
    </div>
  )
}
export default Template1;
